import type { Logger } from '@feature-hub/logger';
import type { VueFormatterServiceInterfaceV1, LocaleServiceV1 } from './feature-service-types';
import mapContent from './contentMapping/contentMapping';
import type { AEMHeadlessContent, EditorJsonContent } from './contentMapping/contentInterfaces';
import { isWltpComplianceSatisfied } from './wltpCompliance';

export interface SsrWltpPrecheckArgs {
  isMarketComplianceEnabled: boolean;
  content: unknown;
  vueFormatterService?: VueFormatterServiceInterfaceV1;
  serviceLocale?: LocaleServiceV1;
  logger: Pick<Logger, 'warn' | 'error'>;
  onCaeMissingLog?: (message: string) => void;
}

export const runSsrWltpPrecheck = async ({
  isMarketComplianceEnabled,
  content,
  vueFormatterService,
  serviceLocale,
  logger,
  onCaeMissingLog,
}: SsrWltpPrecheckArgs): Promise<boolean | undefined> => {
  if (!isMarketComplianceEnabled) return undefined;
  if (!vueFormatterService || !serviceLocale) return undefined;

  try {
    const mapped = mapContent(content as EditorJsonContent | AEMHeadlessContent) as
      EditorJsonContent | undefined;
    const wltpKeys = mapped?.legalText.wltpKey as string[] | undefined;
    if (!wltpKeys?.filter(Boolean).length) return undefined;
    return await isWltpComplianceSatisfied(
      wltpKeys,
      vueFormatterService,
      serviceLocale,
      logger,
      onCaeMissingLog,
    );
  } catch (err) {
    logger.warn('WLTP SSR compliance pre-check failed', err);
    return undefined;
  }
};
